import React, { useContext, useEffect } from "react";
import MyContext from "../MyContext";
import Swal from "sweetalert2";
import { useNavigate, useNavigationType } from "react-router-dom";
//import UserApi from '../../API/APIServices/User';

function PageTabs(props) {
  const navigate = useNavigate(); 
  const { Offescpback, setOffescback } = useContext(MyContext);
  const showModal = () => {
    console.log("Modal is shown!");
  };

  const openPage = (url) => {
    window.location.href = url;
  };
  const openPage1 = (url) => {
    window.location.href = url;
  };

  useEffect(() => {
    const handleKeyPress = async (event) => {
      if (event.altKey && event.key === "i") {
        openPage("/ItemMaster");
      }
      if (event.altKey && event.key === "a") {
        openPage("/AccountMaster");
      }
      if (event.altKey && event.key === "s") {
        openPage1("/SaleInvoice");
        const shouldNavigate = window.confirm(
          "Do you want to navigate to the new page?"
        );
        if (shouldNavigate) {
        }
      }
      if (event.altKey && event.key === "c") {
        openPage("/ModifyCompany1");
      }
      if (event.key === "F2") {
        openPage(props.locationTab);
      }
      if (event.key === "Escape" && Offescpback == 1) {
        const url = window.location.pathname;
        if (url.toLocaleLowerCase().includes("/saleinvoice")) {
          Swal.fire({
            title: "Are you sure?",
            text: "You lost all unsaved changes!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, go back!",
            width: "300px",
            customClass: {
              title: "swal2-custom-title",
              confirmButton: "my-confirm-button",
              cancelButton: "my-cancel-button",
              popup: "swal2-custom-popup",
              htmlContainer: "swal2-custom-text",
              icon: "swal2-custom-icon",
            },
          }).then((result) => {
            if (result.isConfirmed) {
              const extractedNumber = url.match(/\d+$/);
              navigate(`/MasterListReportFormat2?${extractedNumber[0]}`);
              return;
            }
          });
          return;
        }
        console.log(props.joyride);
        if (props.joyride === true) {
          props.stopJoyride();
          console.log("if");
        } else if (props.joyride === undefined) {
          console.log("else if");
        }
        // else if(props.showModal){
        //   handleModalClick();
        //   console.log("else if")
        // }
        else {
          // window.history.back();

          console.log("else");
        }
        console.log(props.modelOpen);
        if (Boolean(props.modelOpen) === true) {
          //alert("props.isModalOpenAttribute   " + props.isModalOpenAttribute)

          if (props.isModalOpenAttribute === true) {
            props.showAttribute(false);
          } else {
            props.setSliderCallBack(false);
          }
        } else if (props.modal === true) {
          props.modalClose();
        } else {
          // window.history.back();
        }
      }
      if (event.key === "F8") {
        window.location.reload();
      }
      if (event.key === "F9") {
        props.showModal();
      }
      if (event.key === "F10") {
        event.preventDefault();
      }
      // console.log(props.locationTab);
    };

    document.addEventListener("keydown", handleKeyPress);

    return () => {
      document.removeEventListener("keydown", handleKeyPress);
    };
  }, []);

  // useEffect(() => {
  //   const handleKeyPress = (event) => {
  //     if(event.altKey && event.key === 'm'){
  //      window.confirm('Do you want to navigate to the new page?');
  //       if (event.altKey && event.key === 's') {
  //         openPage1('/SaleInvoice'); // Replace with the URL of the page you want to open
  //       }
  //     }
  //   };
  //   window.addEventListener('keydown', handleKeyPress);
  //   // Clean up the event listener when the component unmounts
  //   return () => {
  //     window.removeEventListener('keydown', handleKeyPress);
  //   };
  // }, []);

  return <div></div>;
}

export default PageTabs;
